import { IController } from 'angular';
import * as _ from 'lodash';
import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { GraduationPlan as Plan } from '../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class SuperSeniorReviewCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public sort;
  public activeStudentsByCohortFilter;
  public currentCohortFilter;
  public superSeniorThreshold;
  public superSeniors; // students
  public superSeniorsByGradPlan; // studentIds
  public allSuperSeniorIds;
  public superSeniorPlanIncompleteIds;
  public filterOptions;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
    };
    this.currentCohortFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.superSeniorThreshold = _.find(Cohort, { studentYear: 4 });
    this.superSeniors = this.getActiveSuperSeniors();
    this.superSeniorsByGradPlan = this.filterSuperSeniorsByGradPlan();
    this.allSuperSeniorIds = this.superSeniorsByGradPlan.superSeniorIds;
    this.superSeniorPlanIncompleteIds = this.superSeniorsByGradPlan.planIncomplete;
  }

  private getActiveSuperSeniors() {
    const students = this.WizardUtils.getFilteredFlattenedStudents({ status: ['A', 'A-NDG'] });
    return _.filter(students, (student: any) => Number(student.cohort) < this.superSeniorThreshold.value);
  }

  private filterSuperSeniorsByGradPlan() {
    const o = { planIncomplete: [], superSeniorIds: [] };
    _.each(this.superSeniors, (ss: any) => {
      o.superSeniorIds.push(ss.studentId);
      const gradPlanIncomplete = ss.gradPlan === Plan.PLAN_INCOMPLETE.humanName;
      const gradPlanInPast = ss.gradPlan === Plan.PLAN_IN_PAST.humanName;
      if (gradPlanIncomplete || gradPlanInPast) return o.planIncomplete.push(ss.studentId);
    });
    return o;
  }
}
